import { fromFetch as _fromFetch } from 'rxjs/fetch'

const fromFetch = req => _fromFetch(req)

export default fromFetch
